import {
  ADMISSION_TYPE_BOTTLE_SERVICE,
  ADMISSION_TYPE_GUEST_LIST,
  ADMISSION_TYPE_SEASON_PASS,
  ADMISSION_TYPE_TICKET,
  BottleService,
  GuestList,
  Ticket,
} from '@domain/admission';
import { EventPass } from '@domain/passes';
import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

export interface AdmissionResponse {
  [ADMISSION_TYPE_BOTTLE_SERVICE]: BottleService[] | [];
  [ADMISSION_TYPE_GUEST_LIST]: GuestList[] | [];
  [ADMISSION_TYPE_TICKET]: Ticket[] | [];
  [ADMISSION_TYPE_SEASON_PASS]: EventPass[] | [];
}

export const getAdmissionsQueryKey = (eventId: string) => ['admissions-by-event-id', eventId];

const getAdmissionsByEventId = async (eventId: string) => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/events/${eventId}/admissions`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetAdmissions = ({ eventId, options }: { eventId: string; options?: Record<string, boolean> }) => {
  return useGenericQuery<AdmissionResponse, RequestError>(
    getAdmissionsQueryKey(eventId),
    () => getAdmissionsByEventId(eventId),
    {
      ...options,
    }
  );
};
